import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import ServiceQueue from '../types/ServiceQueue';

const getServiceQueuesQuery = graphql(`
  query getServiceQueuesQuery($skipStats: Boolean = true) {
    queues {
      items {
        id
        entrypoints
        name
        memberIds
        routingStrategy
        sessions {
          id
          name
          position
          enteredAt
        }
        inboundRecording
        recoveryTime
        agentTimeout
        rolloverSettings {
          timeout
        }
        status @skip(if: $skipStats) {
          abandonedSessions
          activeSessionCount
          averageWait
          longestWait
          missedSessions
          recipientCount
          totalSessions
          activeRecipientCount
          availableRecipientCount
          estimatedWait
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`);

async function getServiceQueues(fetchStats = false): Promise<ServiceQueue[]> {
  const { data, error } = await getClient().query({
    query: getServiceQueuesQuery,
    fetchPolicy: 'network-only',
    variables: { skipStats: !fetchStats },
  });

  if (error) {
    throw new Error(error.message);
  }

  // return cloned data as we need to mutate it
  // normalize status to {} when not fetched (skipStats=true) so status is always present
  const items = data?.queues?.items ?? [];
  return structuredClone(items).map((q) => ({
    ...q,
    status: q.status ?? {},
  }));
}

export default getServiceQueues;
